import { render, staticRenderFns } from "./SupplierList.vue?vue&type=template&id=13677536&"
import script from "./SupplierList.vue?vue&type=script&lang=ts&"
export * from "./SupplierList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports